module.exports = __webpack_public_path__ + "resources/img/solution_game_gamebase.90dbae75e8e6e43eaf4c6136f8656707.png";